import { styled, keyframes } from '@creditas/stylitas'

interface Props {
  theme: {
    bColorneutral05: string
    bColorneutral01: string
  }
}

const rotation = keyframes`
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
`

const LoadingSpinner = styled.div<Props>`
  align-items: center;
  display: flex;
  padding-left: 21px;
  padding-right: 21.5px;
  position: absolute;
  right: -10px;
  bottom: 10px;

  &:before {
    animation: ${rotation} 0.5s infinite linear;
    border: 1px solid ${({ theme }): string => theme.bColorneutral05};
    border-left-color: ${({ theme }): string => theme.bColorneutral01};
    border-radius: 50%;
    content: '';
    height: 16px;
    opacity: 0;
    opacity: 1;
    transform: translateX(0);
    transition:
      opacity 0.3s ease,
      transform 0.1s 0.3s;
    width: 16px;
  }
`

export { LoadingSpinner }
